// extracted by mini-css-extract-plugin
export default {"greeting":"GameStyles_greeting__4UeUX"};